import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

var root;

if (window.MAM) {
  console.log("MAM object found. Rendering to mam-payment-calculator v4. 2024.02.17");
  // iterate through each widget instance and render if the id exists in the DOM
  window.MAM.configuration.widgets
    .filter((w) => {
      return w.type == "PaymentCalculator";
    })
    .forEach((widget) => {
      widget.siteId = window.MAM.configuration.siteId;
      var elem = document.getElementById(widget.id);
      if (!elem) return;
      var root = ReactDOM.createRoot(elem);
      root.render(
        <React.StrictMode>
          <div class="mam-widget">
            <App config={widget} />
          </div>
        </React.StrictMode>
      );
      window.MAM.logActivity(
        widget.id,
        "PaymentCalculator",
        "Impression",
        null
      );
    });
} else {
  console.log("MAM not found. Rendering to root", window.MAM);
  root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

//serviceWorker.unregister();